export default {"src":"/_next/static/media/GS-X-White.5fb226fa.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};